// extracted by mini-css-extract-plugin
export default {"cardsClass":"Cards_cardsClass__0pdcG"};